import { useState } from 'react';
import { clearStepData } from '@/utils/localStorage';

export function DevTools() {
  const [isVisible, setIsVisible] = useState(false);

  // Only show in development and staging environments
  const shouldShow = window.location.hostname === 'localhost' || 
                    window.location.hostname.endsWith('.herokuapp.com');

  if (!shouldShow) {
    return null;
  }

  const handleClearFlowData = () => {
    // Clear both flow types but preserve other localStorage data like dev auth
    clearStepData('one-off');
    clearStepData('subscription');
    console.log('🗑️ Cleared all flow data from localStorage (preserved auth)');
    alert('Cleared all flow data from localStorage');
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {!isVisible ? (
        <button
          onClick={() => setIsVisible(true)}
          className="bg-indigo-600 hover:bg-indigo-700 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition-colors"
          title="Dev Tools"
        >
          🛠️
        </button>
      ) : (
        <div className="bg-white border border-gray-300 rounded-lg shadow-xl p-4 min-w-[250px]">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold text-gray-800">Dev Tools</h3>
            <button
              onClick={() => setIsVisible(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          </div>
          
          <div className="space-y-2">
            <button
              onClick={handleClearFlowData}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white text-sm py-2 px-3 rounded transition-colors"
            >
              Clear Flow Data
            </button>
          </div>
          
          <div className="mt-3 pt-3 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Environment: {window.location.hostname}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}